import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    playingEpisode: null,
    currentPost: null,
    playing: false,
    loading: false,
    dirty: false,
    episodes: {
      posts: []
    },
    extras: [],
    siteData: {},
    searchQuery: '',
    siteInfo: null
  },
  mutations: {
    SET_EXTRAS (state, payload) {
      state.extras = payload
    },
    ADD_TO_EXTRAS (state, payload) {
      state.extras.posts = state.extras.posts.concat(payload)
    },
    SET_EPISODES (state, payload) {
      state.episodes = payload
    },
    ADD_TO_EPISODES (state, payload) {
      state.episodes.posts = state.episodes.posts.concat(payload)
    },
    SET_SEARCH_QUERY (state, payload) {
      state.searchQuery = payload
    },
    SET_PLAYING_EPISODE (state, payload) {
      state.dirty = true
      state.playingEpisode = payload
    },
    SET_CURRENT_POST (state, payload) {
      state.currentPost = payload
    },
    SET_PLAYER_PLAYING (state, payload) {
      state.playing = payload
    },
    SET_PLAYER_LOADING (state, payload) {
      state.loading = payload
    },
    SET_SITE_INFO (state, payload) {
      state.siteInfo = payload
    }
  },
  actions: {
    setEpisodes ({commit}, payload) {
      commit('SET_EPISODES', payload)
    },
    addToEpisodes ({commit}, payload) {
      commit('ADD_TO_EPISODES', payload)
    },
    setExtras ({commit}, payload) {
      commit('SET_EXTRAS', payload)
    },
    addToExtras ({commit}, payload) {
      commit('ADD_TO_EXTRAS', payload)
    },
    setPlayingEpisode ({commit}, payload) {
      commit('SET_PLAYING_EPISODE', payload)
    },
    setPlayerPlaying ({commit}, payload) {
      commit('SET_PLAYER_PLAYING', payload)
    },
    setPlayerLoading ({commit}, payload) {
      commit('SET_PLAYER_LOADING', payload)
    },
    setCurrentPost ({commit}, payload) {
      commit('SET_CURRENT_POST', payload)
    },
    setSearchQuery ({commit}, payload) {
      commit('SET_SEARCH_QUERY', payload)
    },
    setSiteInfo ({commit}, payload) {
      commit('SET_SITE_INFO', payload)
    }
  },
  getters: {
    episodes: state => {
      if (state.episodes) return state.episodes.posts
    },
    totalEpisodePages: state => {
      if (state.episodes) return state.episodes.pages
    },
    extras: state => {
      if (state.extras) return state.extras.posts
    },
    totalExtraPages: state => {
      if (state.extras) return state.extras.pages
    },
    featuredEpisode: (state, getters) => {
      if (getters.episodes) return getters.episodes[0]
    },
    latestEpisodes: (state, getters) => {
      if (getters.episodes) return getters.episodes.slice(1, 4)
    },
    latestExtras: (state, getters) => {
      if (getters.extras) return getters.extras.slice(0, 3)
    },
    latestEverything: (state, getters) => {
      if (getters.episodes) {
        let episodes = getters.episodes
        if (getters.extras) {
          return episodes.concat(getters.extras)
        }
      }
    },
    currentPost: state => state.currentPost,
    playingEpisode: state => state.playingEpisode,
    playerPlaying: state => state.playing,
    playerLoading: state => state.loading,
    playerDirty: state => state.dirty,
    searchQuery: state => state.searchQuery,
    siteInfo: state => state.siteInfo,
    socialLinks: (state, getters) => {
      if (getters.siteInfo) return getters.siteInfo.social
    },
    shopItems: (state, getters) => {
      if (getters.siteInfo && getters.siteInfo.shopItems) return getters.siteInfo.shopItems.slice(0, 3)
    },
    testimonials: (state, getters) => {
      if (getters.siteInfo && getters.siteInfo.testimonials) return getters.siteInfo.testimonials
    },
    topBarButtons: (state, getters) => {
      if (getters.siteInfo && getters.siteInfo.topBarButtons) return getters.siteInfo.topBarButtons
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js